module.exports = __webpack_public_path__ + "static/media/verdeOccupy_wide.9a56845b.jpg";